<template>
  <qx-card title="列表">
    <section slot="titleRight">
      <qx-permpisions permpisions>
        <el-button type="primary" plain @click="() => switchShowData()">{{showChart ? '列表' : '图表'}}</el-button>
      </qx-permpisions>
      <qx-permpisions permpisions>
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="reportActionBO.ajax?cmd=custMonthlyReport"
          :params="fullSearchData"
          bizName="客户月报表"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
          type="sync"
        />
      </qx-permpisions>
    </section>
    <section class="tablePage" v-show="!showChart">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          >
            <section slot-scope="scope">
              <section v-if="scope.column.property === 'customerCode'" @click="toDetail(scope.row)">
                <span class="primary cur">
                  {{
                  scope.row[scope.column.property]
                  }}
                </span>
              </section>
              <section
                v-if="scope.column.property !== 'customerCode'"
              >{{ scope.row[scope.column.property] }}</section>
            </section>
          </el-table-column>
          <!-- 常规列表项 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.rows"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
    <div style="opacity: 0; height: 1px; background: #FFFFFF;" id="placeholderDiv"></div>
    <section style="min-height: 250px;" v-show="showChart">
      <section v-show="searchData.mode === 1">
        <Order ref="order" chartTitle="订单数量" :width="placeholderDiv+'px'" />
      </section>
      <section class="order-chart-box" v-show="searchData.mode === 2">
        <div class="order-chart-item">
          <Order ref="incomeFee" chartTitle="订单收入" :width="placeholderDiv/2+'px'" />
        </div>
        <div class="order-chart-item">
          <Order ref="orderNum" chartTitle="订单数量" :width="placeholderDiv/2+'px'" />
        </div>
        <div class="order-chart-item">
          <Order ref="mileageNumber" chartTitle="订单里程" :width="placeholderDiv/2+'px'" />
        </div>
        <div class="order-chart-item">
          <Order ref="unitPrice" chartTitle="订单单价" :width="placeholderDiv/2+'px'" />
        </div>
      </section>
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import ExportBtn from 'components/exportBtn';
import Order from './order';
import {
  custMonthlyReport,
} from 'api/report';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
    Order,
  },
  data () {
    return {
      showChart: false,
      searchData: {},
      placeholderDiv: 0,

      tableData: { // 表格相关数据
        loading: false,
        rows: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'dependTime', label: '月份' },
          { prop: 'customName', label: '客户全称' },
          { prop: 'orderNum', label: '订单数量' },
          { prop: 'incomeFee', label: '订单收入（元）' },
          { prop: 'mileageNumber', label: '订单里程（公里）' },
          { prop: 'unitPrice', label: '里程单价（元）' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: custMonthlyReport,
    switchShowData () {
      this.showChart = !this.showChart;
      this.$emit('getChartData');
    },
    // 获取图表数据
    async getChartData (data, config = {}) {
      const res = await custMonthlyReport({
        page: 1,
        // TODO 本来要全部返回，为了快速完成功能所以一次性查10000个
        rows: 10000,
        ...data,
      });
      let resData = [];
      if (!res.failed) {
        if (res.items && res.items.length) {
          resData = res.items;
        }
      }
      return resData;
    },
    // 处理 客户对比 的图表数据
    handleCustomerData (data, xAxisDataName, seriesDataName) {
      let xAxisData = [];
      let seriesData = [];
      // 按订单数量排序由高到低排序
      const sortData = data.sort((a, b) => Number(b.orderNum) - Number(a.orderNum));
      for (let item of sortData) {
        // 只统计前20个
        if (xAxisData.length <= 20) {
          xAxisData.push(item[xAxisDataName]);
          seriesData.push(item[seriesDataName]);
        }
      }
      return {
        xAxisData,
        seriesData,
      };
    },
    // 处理 月份对比 的图表数据
    handleMonthData (data, countName, isCountAverageValue = false) {
      let json = {};
      for (let item of data) {
        if (!json[item.dependTime]) {
          // 如果没有该月份，则设置一个该月份的属性
          json[item.dependTime] = Number(item[countName]) * 1000;
          // 如果没有该月份，则设置为1
          if (isCountAverageValue) {
            json[item.dependTime + '_count'] = 1;
          }
        } else {
          // 如果已存在，则累加
          json[item.dependTime] += Number(item[countName]) * 1000;
          if (isCountAverageValue) {
            // 如果已存在，则+1
            json[item.dependTime + '_count']++;
          }
        }
      }
      let xAxisData = [];
      let seriesData = [];
      for (let name in json) {
        if (isCountAverageValue) {
          if (!name.includes('_count')) {
            // 月份远到近排序
            xAxisData.unshift(name);
            seriesData.unshift((((json[name]) / json[name + '_count']) / 1000).toFixed(2));
          }
        } else {
          xAxisData.unshift(name);
          seriesData.unshift((json[name] / 1000).toFixed(2));
        }
      }
      return {
        xAxisData,
        seriesData,
      };
    },
    // 设置图表数据用于渲染展示
    setChartData (chartName, chartData, config = {}) {
      const options = {
        xAxis: chartData.xAxisData,
        xAxisName: config.xAxisName || '',
        yAxisName: config.yAxisName || '',
        series: [
          {
            data: chartData.seriesData,
            type: 'bar',
          },
        ],
      };
      if (config.breakXAxisNameLength) {
        options.breakXAxisNameLength = chartData.xAxisData.length > config.breakXAxisNameLength ? config.breakXAxisNameLength : 0;
      }
      this.$refs[chartName].setOptions(options);
    },
    // 提供给外部调用的方法，填入数据
    async setBarChartData (data) {
      this.searchData = data;
      if (this.showChart) {
        const resData = await this.getChartData(data);
        if (data.mode === 1) {
          // 客户对比
          const chartData = this.handleCustomerData(resData, 'customName', 'orderNum');
          this.setChartData('order', chartData, {
            xAxisName: '客户全称',
            yAxisName: '订单数量',
            breakXAxisNameLength: 4,
          });
        }
        if (data.mode === 2) {
          // 月份对比
          this.setChartData('incomeFee', this.handleMonthData(resData, 'incomeFee'), {
            xAxisName: '月份',
            yAxisName: '收入（元）',
          });
          this.setChartData('orderNum', this.handleMonthData(resData, 'orderNum'), {
            xAxisName: '月份',
            yAxisName: '数量',
          });
          this.setChartData('mileageNumber', this.handleMonthData(resData, 'mileageNumber'), {
            xAxisName: '月份',
            yAxisName: '里程（公里）',
          });
          this.setChartData('unitPrice', this.handleMonthData(resData, 'unitPrice', true), {
            xAxisName: '月份',
            yAxisName: '单价（元）',
          });
        }
      }
    },
    // 设置图表的宽度
    setChartWidth () {
      const placeholderDiv = document.getElementById('placeholderDiv');
      this.placeholderDiv = placeholderDiv ? placeholderDiv.offsetWidth : 0;
      window.onresize = () => (() => {
        this.placeholderDiv = placeholderDiv ? placeholderDiv.offsetWidth : 0;
      })();
    },
  },
  mounted () {
    this.setChartWidth();
  },
};
</script>

<style lang="scss" scoped>
.order-chart-box {
  // display: flex;
  .order-chart-item {
    display: inline-block;
    width: 50%;
  }
}
</style>
